export const jobsListCacheKey = 'activeAndPastJobs';
export const policyListCacheKey = 'policies';
